// # packages
import * as React from "react";

export interface iProps {
  /**
   * The content.
   */
  children: React.ReactNode | Array<React.ReactNode>;
  /**
   * A unique ID for this tab.
   * This should match the "id" prop of a <Tab> component inside parent <Tabs>
   */
  id: number | string;
}

export class TabContent extends React.Component<iProps> {
  static displayName = "TabContent";

  /**
   * Renders the content.
   *
   * @returns {React.ReactNode}
   */
  public render(): React.ReactNode {
    const { children } = this.props;

    return <div className="tabs__content">{children}</div>;
  }
}
